import type {
  AdyenCheckoutError,
  Dropin,
  PaymentFailedData,
} from "@adyen/adyen-web";
import type { RefObject } from "react";
import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

type AdyenStore = {
  dropin?: Dropin;
  setDropin: (dropin?: Dropin) => void;
  reloadAdyenDropIn: (ref?: RefObject<HTMLDivElement | null>) => void;
  adyenDropInError?: PaymentFailedData | AdyenCheckoutError;
  setAdyenDropInError: (error?: PaymentFailedData | AdyenCheckoutError) => void;
};

export const adyenStore = create<AdyenStore>()(
  subscribeWithSelector((set) => ({
    dropin: undefined,
    setDropin: (dropin) => set({ dropin }),
    reloadAdyenDropIn: (ref?: RefObject<HTMLDivElement | null>) => {
      if (!ref?.current) {
        return;
      }

      set((state) => {
        if (state.dropin) {
          state.dropin.unmount();

          if (ref.current) {
            state.dropin.mount(ref.current);
          }

          return {
            dropin: state.dropin,
          };
        }

        return state;
      });
    },
    adyenDropInError: undefined,
    setAdyenDropInError: (error) => set({ adyenDropInError: error }),
  })),
);
